enum MessageType {
  Actions = "ACTIONS",
  GetLiveStatus = "GET_LIVE_STATUS",
  Teaching = "TEACHING",
  MoveStation = "MOVE_STATION",
  TorizonUpdateReady = "TORIZON_UPDATE_READY",
  TorizonUpdateCheck = "TORIZON_UPDATE_CHECK",
}

export default MessageType;
